import cx from 'classnames';

import Typography from '~/components/Typography';

interface Props {
  accentColor: string;
  fontFamily: string;
  txtColor: string;
  text: string;
  Icon: any;
}

const LineItem = ({ accentColor, fontFamily, txtColor, text, Icon }: Props) => {
  return (
    <div className="flex items-center space-x-2">
      <div
        style={{
          color: accentColor,
        }}
      >
        <Icon
          className={cx({
            'h4 w-4 flex-none': true,
          })}
        />
      </div>
      <Typography as="span" size="xs" weight="light" fontFamily={fontFamily} color={txtColor}>
        {text}
      </Typography>
    </div>
  );
};

export default LineItem;
